import { useState } from "react";
import StarSharp from "@mui/icons-material/StarSharp";

const StarRating = ({ rating }) => {
  const [ratingTemp, setRatingTemp] = useState(rating);

  return (
    <div className="flex items-center">
      {[...Array(5)].map((_, i) => (
        <div
          key={i}
          className={`cursor-pointer ${
            i < ratingTemp ? "text-yellow-500" : "text-gray-500"
          }`}
          onClick={() => setRatingTemp(i + 1)} // Update rating when clicked
        >
          <StarSharp sx={{ fontSize: 20 }} />
        </div>
      ))}
    </div>
  );
};

export default StarRating;
